// Cửa sổ vùng tài nguyên: sản vật, quái, thanh Trữ Lượng, giao / thu Lịch Luyện (WORLD §2, §3.2).
import type { JSX } from 'preact';
import { t } from '@i18n/t';
import { formatFull } from '@i18n/format';
import { BALANCE } from '@data/balance';
import { templateDef, zoneDef } from '@data/content/zones';
import { isWalletCurrency } from '@data/currencies';
import { cultivation, stopTrial, startTrial, trialBlock, zoneReserve } from '@state/modules/cultivation';
import { closeWindows } from '@state/modules/ui';
import { NumBar } from '../../kit/NumBar';
import { ItemSlot } from '../../kit/ItemSlot';
import { TextButton } from '../../kit/TextButton';

export function ZoneWindow({ zoneId }: { zoneId: string }): JSX.Element {
  const z = zoneDef(zoneId);
  const c = cultivation.value;
  const here = c.idle.mode === 'trial' && c.idle.trialZoneId === zoneId;
  const reserve = zoneReserve(zoneId);
  const block = trialBlock(zoneId);
  return (
    <>
      <p class="ht-block">{t(`${zoneId}.desc`)}</p>
      <NumBar
        id="zone-reserve"
        value={reserve}
        max={100}
        ariaLabel={t('ui.zone.reserve', { n: Math.round(reserve) })}
      />
      <small class="zone-note">
        {reserve < BALANCE.RESERVE_LOW ? t('ui.zone.low') : t('ui.zone.regen', { n: z.regenPerWatch })}
      </small>
      <div class="zone-yield" data-id="zone-yield">
        {z.gather.map((g) => (
          <span class="ht-chip" key={g.id}>
            {t(isWalletCurrency(g.id) ? `currency.${g.id}` : `${g.id}.name`)} ·{' '}
            {t('ui.zone.perWatch', { n: formatFull(Math.round(g.perHour * 2 * 10) / 10) })}
          </span>
        ))}
      </div>
      {z.monsters.length > 0 && (
        <div class="zone-mobs">
          {z.monsters.map((m) => {
            const tp = templateDef(m.template);
            return (
              <ItemSlot
                key={m.template}
                size="sm"
                art={`${import.meta.env.BASE_URL}assets/quai/${tp.art}.webp`}
                label={t(`enemy.${tp.id}.name`)}
              />
            );
          })}
        </div>
      )}
      <div class="ht-actions">
        {here ? (
          <TextButton id="zone-stop" variant="ghost" onClick={() => stopTrial() && closeWindows()}>
            {t('ui.zone.stop')}
          </TextButton>
        ) : (
          <TextButton
            id="zone-go"
            disabled={block !== null}
            onClick={() => startTrial(zoneId) && closeWindows()}
          >
            {t('ui.zone.go')}
          </TextButton>
        )}
        <span class="ht-chip">{t('ui.zone.share', { n: Math.round(BALANCE.TRIAL_QI_SHARE * 100) })}</span>
      </div>
      {block && block !== 'same' && <p class="ht-reason">{t(`ui.zone.block.${block}`)}</p>}
    </>
  );
}
